const TCListItem = ({ item }) => {
  return (
    <>
      {item.map((content, index) => (
        <div className="list-item" key={index}>
          <div className="item-number">{index + 1}</div>
          <div className="item-content">{content}</div>
        </div>
      ))}
    </>
  );
};

export default TCListItem;
